<template>
  <section
    v-if="instructor"
    class="bg-white rounded border border-grey-300 overflow-hidden shadow mt-4"
  >
    <div class="w-full bg-white h-auto">
      <div class="border-b border-grey-300 px-5 py-4">
        <div class="flex justify-between items-center">
          <p class="text-lg font-bold">{{ $t('frontend_groovemember_left_panel_instructor_heading') }}</p>
        </div>
      </div>
      <div class="px-6 py-4">
        <div class="flex items-center">
          <img
            v-if="instructor.profile_image"
            class="h-12 w-12 rounded-full object-cover"
            :src="instructor.profile_image"
          />
          <p class="pl-4 font-bold text-md">{{ instructor.name }}</p>
        </div>
        <div class="pt-4 pb-8">
          <p class="text-md leading-tight text-grey-600">
            {{ instructor.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Instructor',
  props: ['instructor'],
};
</script>